export default __webpack_public_path__ + "static/frame-351ce7f93f47fd6d93ddc9f1802dc529.png";